import { LegendItemInterface } from "../../../../Models/Common/List/LegendInterface";
import styled from "styled-components";
import { ColorEnum } from "../../../../Utilities/Enums/ColorEnums";
import QueryBuilderHelper from "../../../../Utilities/Helpers/QueryBuilderHelper";
import { useLocation, useSearchParams } from "react-router-dom";

type LegendColorTypes = { [K in ColorEnum]: {
    type: K,
    color: string,
} };
const LegendColors: LegendColorTypes = {
    [ColorEnum.GRAY]: {
        type: ColorEnum.GRAY,
        color: "var(--textCancelColor) !important",
    },
    [ColorEnum.GREEN]: {
        type: ColorEnum.GREEN,
        color: "var(--textSuccessColor) !important",
    },
    [ColorEnum.RED]: {
        type: ColorEnum.RED,
        color: "var(--textDangerColor) !important",
    },
    [ColorEnum.YELLOW]: {
        type: ColorEnum.YELLOW,
        color: ""
    },
    [ColorEnum.BLUE]: {
        type: ColorEnum.BLUE,
        color: ""
    }
}

const DivContainer = styled.div<{ $isSelected: boolean }>`
  background-color: ${(props) => props.$isSelected ? 'var(--fieldResetAllBGPrimaryColor)' : 'transparent'};
  padding: 0.25rem 0.45rem;
  border-radius: 4px;
  gap: 10px;
  display: flex;
  flex-direction: row; 
  align-items: center;
`

const DivTitle = styled.div<{ $legendType: ColorEnum }>`
  color: ${(props) => LegendColors[props.$legendType].color};
  font-weight: 500;
`

const DivCount = styled.div<{ $legendType: ColorEnum }>`
  color: white;
  background-color: ${(props) => LegendColors[props.$legendType].color};
  border-radius: 4px;
  width: min-content;
  height: fit-content;
  padding: 0.05rem 0.35rem;
  font-weight: 500;
  text-align: center;
`
// type LegendItemProps = {
//     legendProps: LegendItemInterface;
//     paramName: string
// };

type LegendItemProps = LegendItemInterface & { paramName: string };

const LegendItem = (legendProps: LegendItemProps) => {
    const location = useLocation()
    //search params
    const queryParams = new URLSearchParams(location.search);
    const [searchParams, setSearchParams] = useSearchParams(queryParams);

    const { title, color, count, id, ...props } = legendProps;
    const status = QueryBuilderHelper.DefaultQueryFilterValue(legendProps.paramName ?? 'status') ?? 0 

    const isSelected = status == id || (status == "all" && id == 0)
    return <DivContainer $isSelected={isSelected}>
        <DivTitle $legendType={color}>{title}</DivTitle>
        <DivCount $legendType={color}>{count}</DivCount>
    </DivContainer>
}

export default LegendItem;